// extracted by mini-css-extract-plugin
export var linkText = "_n5-0";